export const isAdmin = false;

const hostname = window.location.hostname;
const port = isAdmin?8001:8000; 
console.log(hostname)
// export const url = `http://${hostname}:${port}/api`;
export const url = `https://demopos.nextechltd.in/api`;
export const fe_version = process.env.REACT_APP_FE_VERSION || '1.0.0';